module.exports = __webpack_public_path__ + "static/data_bar_1-1103a971662ee8bc79c5ae1fc61c1f01.png";